import { getMarketingUrl as buildMarketingUrl } from "@sill/shared";

const MARKETING_URL =
  import.meta.env.VITE_MARKETING_URL || "https://usesill.com";

export function getMarketingUrl(
  path: string,
  params?: Record<string, string>,
): string {
  return buildMarketingUrl(MARKETING_URL, path, params);
}
